/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsText: {
  name: 'text';
  data: string;
} = {
  name: 'text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a1 1 0 1 1-2 0V5h-6v14h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2V5H5v2a1 1 0 0 1-2 0V5Z" fill="currentColor"/></svg>`,
};
